import { useParams } from 'react-router-dom';

import { paths } from '../../utils/navigation';
import { permissionsByType } from '../MobileUsers/mobileUserRolePermissions';
import { ProtectedRoute } from './ProtectedRoute';

interface UsersProtectedRouteProps {
  userId?: number;
  children: React.ReactNode;
}

export function UsersProtectedRoute({ children, userId = null }: UsersProtectedRouteProps) {
  const { userId: userIdFromParams } = useParams();
  const adminPermissions = permissionsByType.adminFrontend;
  const canEditPermissions = adminPermissions.includes('viewAndCreateUsers');

  const canAccessUsersRouteWithConditions = () => {
    if (userIdFromParams && userId) {
      if (userId === parseInt(userIdFromParams)) {
        return true;
      }
    }
    if (canEditPermissions) {
      return true;
    }
    return false;
  };

  return (
    <ProtectedRoute
      allowSuperAdmin={true}
      allowAdmin={true}
      allowSupport={true}
      customAccessCondition={canAccessUsersRouteWithConditions}
      redirectTo={paths.home.index}
    >
      {children}
    </ProtectedRoute>
  );
}
